module.exports = __webpack_public_path__ + "img/alnilam.8e96f0fb.jpg";